export default "__VITE_ASSET__JbsyFjBm__"